export const isUrlAbsolute = (url: string): boolean =>
  // eslint-disable-next-line lodash/prefer-startswith
  url.indexOf("://") > 0 || url.indexOf("//") === 0;
